import React, { Component } from "react";

class QuickStockCard extends Component {
    render() {
        const { stockItem, warehouseStocks, onAddStock, onRemoveStock } = this.props;
        
        // Toplam stok hesapla - parseFloat ile sayıya çevir
        const totalStock = warehouseStocks 
            ? warehouseStocks.reduce((sum, stock) => sum + parseFloat(stock.quantity || 0), 0) 
            : 0;
        const availableStock = warehouseStocks 
            ? warehouseStocks.reduce((sum, stock) => sum + parseFloat(stock.available_quantity || 0), 0) 
            : 0;
        const reservedStock = totalStock - availableStock;
        
        // Min stok kontrolü
        const minStock = parseFloat(stockItem?.min_stock_level || 0);
        const isLowStock = totalStock <= minStock && totalStock > 0;
        const isOutOfStock = totalStock === 0;
        
        // Renk ve stil belirleme - Modern yaklaşım
        let statusColor = '#17a2b8'; // info blue
        let statusBg = '#e7f6f8';
        let statusText = 'Stok Durumu: Normal';
        let statusIcon = 'icon-check';
        
        if (isOutOfStock) {
            statusColor = '#dc3545'; // danger red
            statusBg = '#f8e7e9';
            statusText = 'Stok Tükendi';
            statusIcon = 'icon-close';
        } else if (isLowStock) {
            statusColor = '#ffc107'; // warning yellow
            statusBg = '#fff9e6';
            statusText = 'Düşük Stok Uyarısı';
            statusIcon = 'icon-info';
        }
        
        return (
            <div className="row clearfix">
                <div className="col-lg-8 col-md-12">
                    <div className="card" style={{
                        borderLeft: `5px solid ${statusColor}`,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
                    }}>
                        <div className="body">
                            <div className="row">
                                <div className="col-md-6 text-center" style={{borderRight: '2px solid #e9ecef'}}>
                                    <div style={{
                                        display: 'inline-block',
                                        padding: '15px',
                                        borderRadius: '15px',
                                        background: statusBg,
                                        marginBottom: '15px'
                                    }}>
                                        <i className="icon-layers" style={{fontSize: '40px', color: statusColor}}></i>
                                    </div>
                                    <h6 className="text-muted mb-2" style={{fontSize: '13px', fontWeight: '600', letterSpacing: '1px'}}>
                                        TOPLAM STOK
                                    </h6>
                                    <h1 className="display-1 font-weight-bold mb-0" style={{color: statusColor, fontSize: '72px'}}>
                                        {Math.round(totalStock)}
                                    </h1>
                                    <p className="text-muted mb-3" style={{fontSize: '18px', fontWeight: '500'}}>adet</p>
                                    
                                    {(isOutOfStock || isLowStock) && (
                                        <div className="mt-3">
                                            <span className="badge" style={{
                                                backgroundColor: statusBg,
                                                color: statusColor,
                                                fontSize: '13px',
                                                padding: '8px 16px',
                                                fontWeight: '600',
                                                border: `2px solid ${statusColor}`,
                                                borderRadius: '20px'
                                            }}>
                                                <i className={statusIcon}></i> {statusText}
                                                {isLowStock && !isOutOfStock && ` (Min: ${Math.round(minStock)})`}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                
                                <div className="col-md-6">
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <h6 className="text-dark" style={{fontWeight: '700', fontSize: '15px'}}>
                                                <i className="icon-graph" style={{color: statusColor}}></i> Stok Detayları
                                            </h6>
                                        </div>
                                    </div>
                                    
                                    <div style={{
                                        padding: '12px',
                                        borderRadius: '10px',
                                        background: '#f8f9fa',
                                        marginBottom: '12px'
                                    }}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{color: '#6c757d', fontSize: '13px', fontWeight: '500'}}>
                                                <i className="icon-check" style={{color: '#28a745'}}></i> Kullanılabilir
                                            </span>
                                            <strong style={{color: '#28a745', fontSize: '18px', fontWeight: '700'}}>
                                                {Math.round(availableStock)}
                                            </strong>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span style={{color: '#6c757d', fontSize: '13px', fontWeight: '500'}}>
                                                <i className="icon-lock" style={{color: '#ffc107'}}></i> Rezerve
                                            </span>
                                            <strong style={{color: '#ffc107', fontSize: '18px', fontWeight: '700'}}>
                                                {Math.round(reservedStock)}
                                            </strong>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span style={{color: '#6c757d', fontSize: '13px', fontWeight: '500'}}>
                                                <i className="icon-info" style={{color: '#17a2b8'}}></i> Min. Stok
                                            </span>
                                            <strong style={{color: '#17a2b8', fontSize: '18px', fontWeight: '700'}}>
                                                {Math.round(minStock)}
                                            </strong>
                                        </div>
                                    </div>
                                    
                                    <div className="row mt-4">
                                        <div className="col-6">
                                            <button 
                                                className="btn btn-block"
                                                onClick={onAddStock}
                                                style={{
                                                    background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    fontWeight: '600',
                                                    borderRadius: '8px',
                                                    padding: '10px',
                                                    boxShadow: '0 4px 8px rgba(40, 167, 69, 0.2)'
                                                }}
                                            >
                                                <i className="icon-plus"></i> Stok Ekle
                                            </button>
                                        </div>
                                        <div className="col-6">
                                            <button 
                                                className="btn btn-block"
                                                onClick={onRemoveStock}
                                                disabled={totalStock === 0}
                                                style={{
                                                    background: totalStock === 0 ? '#e9ecef' : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                    color: totalStock === 0 ? '#6c757d' : 'white',
                                                    border: 'none',
                                                    fontWeight: '600',
                                                    borderRadius: '8px',
                                                    padding: '10px',
                                                    boxShadow: totalStock === 0 ? 'none' : '0 4px 8px rgba(220, 53, 69, 0.2)'
                                                }}
                                            >
                                                <i className="icon-minus"></i> Stok Çıkar
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-12">
                    <div className="card" style={{
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        borderTop: `4px solid ${statusColor}`,
                        background: 'white'
                    }}>
                        <div className="body">
                            <h6 className="text-dark mb-4" style={{fontWeight: '700', fontSize: '15px'}}>
                                <i className="icon-home" style={{color: statusColor}}></i> Depo Dağılımı
                            </h6>
                            <div className="mt-3">
                                {warehouseStocks && warehouseStocks.length > 0 ? (
                                    warehouseStocks.map((stock, index) => (
                                        <div key={index} style={{
                                            padding: '12px',
                                            borderRadius: '8px',
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                                            marginBottom: '10px',
                                            border: '1px solid #e9ecef',
                                            transition: 'all 0.3s ease'
                                        }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span style={{
                                                    color: '#495057',
                                                    fontSize: '14px',
                                                    fontWeight: '600'
                                                }}>
                                                    <i className="icon-drawer" style={{color: statusColor, marginRight: '5px'}}></i>
                                                    {stock.warehouse?.name || 'Bilinmeyen Depo'}
                                                </span>
                                                <strong style={{
                                                    color: statusColor,
                                                    fontSize: '20px',
                                                    fontWeight: '700'
                                                }}>
                                                    {Math.round(parseFloat(stock.quantity || 0))}
                                                </strong>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <small style={{color: '#6c757d', fontSize: '12px'}}>
                                                    <i className="icon-check" style={{color: '#28a745'}}></i> Kullanılabilir
                                                </small>
                                                <small style={{
                                                    color: '#28a745',
                                                    fontWeight: '700',
                                                    fontSize: '13px'
                                                }}>
                                                    {Math.round(parseFloat(stock.available_quantity || 0))} adet
                                                </small>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center" style={{padding: '30px 0'}}>
                                        <div style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            background: '#f8f9fa',
                                            margin: '0 auto 15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <i className="icon-drawer" style={{fontSize: '30px', color: '#dee2e6'}}></i>
                                        </div>
                                        <p className="text-muted mb-0" style={{fontSize: '13px'}}>Henüz depoda stok yok</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuickStockCard;

